export function checkForStories(link) {
    const stories = link.match(/(?:instagram\.com|instagr\.am)\/stories\/([A-Za-z0-9-_\.]+)\/([A-Za-z0-9-_\.]+)/im)
    const highlights = link.match(/(?:instagram\.com|instagr\.am)\/stories\/highlights\/([A-Za-z0-9-_\.]+)/im)
    return !!(stories || highlights)
}
export function checkForReels(link) {
    const reels = link.match(/(?:instagram\.com|instagr\.am)\/reel[s]?\/([A-Za-z0-9-_\.]+)/im)
    return !!reels
}
export function checkForPosts(input) {
    const posts = input.match(/^(https:\/\/|http:\/\/)?(www\.)?(instagram\.(com|org)|instagr\.am)(\/(p|tv))/gims)
    if (posts) {
        return true
    }
}

export function isProfileLink(input){
    const profile = input.match(/(?:instagram\.com|instagr\.am)\/([A-Za-z0-9-_\.]+)\/?$/gim)
    return !!profile
}

export function isInstagramContent(input){
    return checkForPosts(input) || checkForReels(input) || checkForStories(input)
}

export function isInstagramPage(){
    return window?.location.pathname?.includes('instagram') || window?.location?.href.includes('instagram')
}

export function isInstagramContext(string = ''){
    return  isInstagramPage() || string.includes("instagram.com")
}
